import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import { markPaymentRequestDisbursementPaid, getPaymentRequest } from "redux/erp/paymentRequestSlice";
import { Modal, Button, FormInput } from 'components/common';
import { formatCurrency, requestCurrencyOf } from "../common/lineCurrency";

/**
 * Payment Accountant records a Non-HSBC payment made outside the Portal. Reference and
 * remark are optional; the requester, the accountant in charge, the Chief Accountant
 * and the rest of the team are notified once it is recorded.
 */
const MarkPaidModal = ({ show, onHide, paymentRequest: pr }) => {
  const dispatch = useDispatch();
  const [reference, setReference] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const close = () => { setReference(""); setNote(""); onHide(); };
  const onSubmit = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await dispatch(markPaymentRequestDisbursementPaid({ id: pr.id, reference: reference.trim(), note: note.trim() })).unwrap();
      await dispatch(getPaymentRequest(pr.id));
      toast.success("Payment recorded as paid.");
      close();
    } catch (e) {
      toast.error(e?.error || e?.message || "Could not record the payment.");
    } finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={close} title={`Mark ${pr?.code} as paid`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={close}>Cancel</Button>
        <Button variant="success" size="sm" leftIcon={FaCheckCircle} loading={busy} aria-busy={busy} onClick={onSubmit}>
          {busy ? "Recording…" : "Record as paid"}
        </Button>
      </>}>
      <div className="geist-scope tw-space-y-3">
        <p className="tw-m-0 tw-text-sm tw-text-geist-fg-2">
          <strong className="tw-text-geist-fg">{formatCurrency(pr?.total_amount, requestCurrencyOf(pr?.items || []))}</strong>
          {pr?.payee ? <> to <strong className="tw-text-geist-fg">{pr.payee}</strong></> : null} — paid outside the Portal.
          The requester and Accounting are notified.
        </p>
        <FormInput label="Payment reference" placeholder="Bank reference / payment order no. (optional)"
          value={reference} onChange={(e) => setReference(e.target.value)} />
        <FormInput label="Remark" type="textarea" rows={3} placeholder="Optional, e.g. paid by BIDV on 28/10"
          value={note} onChange={(e) => setNote(e.target.value)} />
      </div>
    </Modal>
  );
};

MarkPaidModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  paymentRequest: PropTypes.object,
};

export default MarkPaidModal;
